import { Star } from "lucide-react";

export function StarRating({ value = 0, size = 14, interactive = false, onChange = () => {}, testid }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testid}>
      {stars.map((s) => {
        const filled = value >= s;
        const half = !filled && value >= s - 0.5;
        const Icon = (
          <Star
            size={size}
            className={
              filled || half
                ? "text-[#e8478e]"
                : "text-[#d3c9b7]"
            }
            fill={filled ? "currentColor" : "none"}
            strokeWidth={1.6}
          />
        );
        if (!interactive) return <span key={s}>{Icon}</span>;
        return (
          <button
            type="button"
            key={s}
            onClick={() => onChange(s)}
            data-testid={testid ? `${testid}-${s}` : undefined}
            className="hover:scale-110 transition-transform"
            aria-label={`${s} star${s > 1 ? "s" : ""}`}
          >
            {Icon}
          </button>
        );
      })}
    </div>
  );
}
